import type { NormalizedEvent } from "@/services/types/agent-gateway";
import { CircleAlert } from "lucide-react";

type ErrorEvent = Extract<NormalizedEvent, { type: "error" }>;

export function AgentError({ event }: { event: ErrorEvent }) {
  return (
    <div
      className="flex items-start gap-3 rounded-lg border border-red-200 bg-red-50 p-4 text-red-700 text-sm"
      role="alert"
    >
      <CircleAlert aria-hidden="true" className="mt-0.5 size-4 shrink-0" />
      <p className="min-w-0 [overflow-wrap:anywhere]">
        {event.content.message}
      </p>
    </div>
  );
}
